<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top
                color="red"
                :timeout="timeout"
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container class="mt-10">
            <div>
                <v-row>
                    <v-col cols="1">
                        <v-btn small rounded  icon @click="previousDay" class="mr-4"><v-icon>mdi-arrow-left</v-icon></v-btn>

                    </v-col>
                    <v-col cols="8">
                        <h2>{{ actualdatefr }}</h2>
                    </v-col>
                    <v-col cols="3">
                        <v-btn small rounded  icon @click="nextDay" class="mr-4"><v-icon>mdi-arrow-right</v-icon></v-btn>
                        <v-btn small @click="setToday" class="info mr-4 float-right">Revenir Aujourd'hui</v-btn>
                    </v-col>
                </v-row>
            </div>
            <div v-if="loading">
                <v-row>
                    <v-col>
                        <v-flex align-center>
                            <v-img max-width="700px" src="@/assets/loader.gif"></v-img>
                        </v-flex>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && noConnectRdv && agendas.length == 0">
                <v-row>
                    <v-col>
                        <v-alert color="indigo" dark>
                          <h1>Pas de tâches pour aujourd'hui ?</h1>
                          <p style="font-size: 1.5em">Profitez en pour travailler votre portefeuille client !</p>
                          <v-btn class="info" @click="goToPortefeuille()">Voir mon portefeuille</v-btn>
                        </v-alert>
                    </v-col>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div v-for="rdv in rdvs" v-bind:key="rdv.id">
              <v-sheet
                elevation="6"
                class="mt-2 pl-2 pr-2"
              >
                <v-row v-if="rdv.assignedagentid == '' || (rdv.assignedagentid == userId && rdv.finalstatus == 'todo')" style="background-color: rgba(255, 255, 255, .6);" class="mb-2">
                    <v-col>
                      <h4 class="text-left">Rendez-vous <strong>Hyundai Connect</strong> Le {{rdv.computed.date}} à {{rdv.computed.heure}}</h4>
                        <p class="text-left">
                            Contacter {{rdv.name}} par {{rdv.contactmethod}}
                            <br>
                            GSM :
                                <span v-if="rdv.contactmethod == 'WhatsApp'"><a :href="'whatsapp://send?phone=' + rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Téléphone'"><a :href="'tel:'+rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Skype'">{{rdv.gsm}}</span>
                            <br>
                            Mail : {{rdv.mail}}
                            <span v-if="rdv.contactmethod == 'Skype'">
                            <br>
                                Skype : <a :href="'skype:'+rdv.skypeid+'?call'">{{rdv.skypeid}}</a>
                        </span>
                        </p>
                    </v-col>
                    <v-col class="text-left">
                        <v-btn v-if="rdv.assignedagentid == ''" color="primary" class="float-right" @click="acceptRdv(rdv)">J'accepte la mission</v-btn>
                        <v-btn v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel == ''" color="primary" class="float-right" :to="{ name: 'ViewConnect', params: { id: rdv.id }}">Faire l'appel</v-btn>
                        <p v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel != ''">
                            <strong>Status de l'appel :</strong> {{ rdv.customdata.statusappel }}<br>
                            <span v-if="rdv.customdata.budgetclient != ''"><strong>Budget du client :</strong>{{ rdv.customdata.budgetclient }}<br></span>
                            <span v-if="rdv.customdata.typeachatclient != ''"><strong>Type d'achat :</strong> {{ rdv.customdata.typeachatclient }}<br></span>
                            <span v-if="rdv.customdata.interetclient != ''"><strong>Niveau Intérêt du Client :</strong> {{ rdv.customdata.interetclient }}<br></span>
                            <span v-if="rdv.customdata.prochaineactionclient != ''"><strong>Prochaine action planifiée :</strong> {{ rdv.customdata.prochaineactionclient }}<br></span>
                            <span v-if="rdv.customdata.commentaireclient != ''"><strong>Commentaire :</strong> {{ rdv.customdata.commentaireclient }}<br></span>
                            <span v-if="rdv.customdata.statusappel == 'Effectué'"><strong>Intéressé par :</strong> <span v-for="model in rdv.customdata.modelsclient" v-bind:key="model.name"><span v-if="model.selection == true">{{model.name}}, </span></span></span>
                        </p>

                    </v-col>
                </v-row>
              </v-sheet>
            </div>
            <div v-for="agenda in agendas" v-bind:key="agenda.id">
              <v-sheet
                  elevation="6"
                  class="mt-2 pl-2 pr-2"
                >
                  <v-row :class="agenda.status=='done'?'background-done':''">
                      <v-col cols="2">
                        <v-icon large :title="agenda.type">{{agenda.customdata.icon}}</v-icon>
                        <v-icon large class="ml-2" title="Vous avez effectué l'action" v-if="agenda.status === 'done'">mdi-check-circle-outline</v-icon>
                        <v-icon large class="ml-2" title="L'action a été reportée" v-if="agenda.status === 'reporte'">mdi-calendar-clock</v-icon>

                        <v-icon color="green" class="ml-2" title="Vous considérez le sentiment du client positif" large v-if="agenda.customdata.retour.retourEvaluation == 'Positif'">mdi-emoticon-happy-outline</v-icon>
                        <v-icon color="red" class="ml-2" title="Vous considérez le sentiment du client négatif" large v-if="agenda.customdata.retour.retourEvaluation == 'Négatif'">mdi-emoticon-sad-outline</v-icon>
                        <v-icon color="orange" class="ml-2" title="Vous ne savez pas quoi penser du sentiment du client" large v-if="agenda.customdata.retour.retourEvaluation == 'Je ne sais pas'">mdi-emoticon-neutral-outline</v-icon>
                      </v-col>
                      <v-col class="text-left">
                          <h4 class="text-left">Le {{agenda.computed.date}} à {{agenda.computed.heure}}</h4>
                          <p class="text-left">
                              {{agenda.type}} Avec {{agenda.dependencies.name}}
                          </p>
                      </v-col>
                      <v-col v-if="agenda.status === 'done'">
                        <p class="text-left"><strong>Commentaire sur le retour : </strong> {{agenda.customdata.retour.retourCommentaire}}</p>
                      </v-col>
                      <v-col class="text-left" :class="agenda.status=='done'?'background-done':''">
                        <v-btn v-if="agenda.status != 'todo'" color="primary" class="float-right" @click="goToConnectHistory(agenda.hconnectrdvid,agenda.id)">Voir l'historique</v-btn>
                        <v-btn v-if="agenda.status == 'todo'" color="primary" class="float-right" @click="goToConnectHistory(agenda.hconnectrdvid,agenda.id)">Faire un retour</v-btn>
                      </v-col>
                  </v-row>
              </v-sheet>
            </div>
        </v-container>
    </v-app>
</template>

<script>

    import NProgress from "nprogress";

    export default {
        name: 'ListeConnect',
        data() {
            return {
                timeout: 4000,
                actualdate: '',
                actualdatefr: '',
                loading: false,
                snackbar: false,
                errorMsg: '',
                rdvs: [],
                agendas: [],
                titrePrincipal: 'Rendez-vous du jour',
                noConnectRdv: true
            }
        },
        computed: {
            sitename() {
                return this.$store.state.user.sitename
            },
            userId() {
                return this.$store.state.user.id
            }
        },
        methods: {
            showEvent({ nativeEvent}){
                nativeEvent.stopPropagation()
            },
            goToPortefeuille(){
              this.$router.push({
                name: "ListeConnectHistory"
              })
            },
            goToConnectHistory(rdvid,agendaid) {
                this.$router.push({
                    name: "ListeConnectHistory",
                    params: {
                        rdvid: rdvid,
                        agendaid : agendaid
                    }
                })
            },
            setToday(){
                this.actualdate = new Date()
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            nextDay(){
                this.actualdate.setDate(this.actualdate.getDate() + 1)
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            previousDay(){
                this.actualdate.setDate(this.actualdate.getDate() - 1)
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            getRdv(date){
                NProgress.start()
                this.loading = true
                let params = {}

                let tmp = new Date(date)
                var month = parseInt(tmp.getMonth()) + 1
                var day = tmp.getDate()
                var year = tmp.getFullYear()
                let myDate = year+"-"+month+"-"+day

                params.action = 'getTodayRdv'
                params.date = myDate
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            console.log("Erreur")
                            // TODO : faire une snackbar
                            NProgress.done()
                            return false
                        }
                        let results = []

                        data.data.data.rdvs.forEach((element) => {
                            results.push(element)
                            if((element.finalstatus == 'todo' && element.assignedagentid == this.userId) || element.finalstatus == ''){
                              this.noConnectRdv = false
                            }
                        })
                        this.rdvs = results
                        this.agendas = data.data.data.agendas
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            init(){

                this.actualdatefr = getFrenchDate(new Date())
                this.actualdate = new Date()
                this.snackbar = false
                this.errorMsg =  ''

                this.getRdv(this.actualdate)

            },
            acceptRdv(rdv){
                if(!confirm('Etes vous sur de vouloir prendre en charge le prospect '+rdv.name+'?')){
                    return false;
                }
                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'acceptRdv'
                params.id = rdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            console.log("Erreur")
                            this.errorMsg = 'Impossible de changer le status du RDV. Veuillez réessayer dans quelques instants'
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }
                        this.getRdv(this.actualdate)
                        NProgress.done()
                    })
                    .catch( () => {
                        this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            }
        },
        mounted: function () {
            this.init()
        }
    }
    function getFrenchDate(todayTime) {
        var jourName = ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche']
        var month = parseInt(todayTime.getMonth()) + 1
        if(month < 10)
          month = '0' + month
        var day = todayTime.getDate()
        if(day < 10)
          day = '0' + day
        var year = todayTime.getFullYear()
        var jour = todayTime.getDay()

        return jourName[jour] + " " + day + "/" + month + "/" + year
    }
</script>

<style>
  .background-done{
    background-color: #a5d6a7;
  }
</style>
